var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTickBadgeIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42.917 42.917",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_badge_895503_000000",
    d: "M39.242,21.458l3.675-5.74L36.855,12.58l.322-6.813-6.813.322L27.2,0l-5.74,3.675L15.718,0,12.58,6.062,5.74,5.74l.322,6.813L0,15.718l3.675,5.74L0,27.2l6.062,3.138L5.74,37.15l6.813-.322,3.165,6.089,5.74-3.675,5.74,3.675,3.138-6.062,6.813.322-.322-6.813L42.917,27.2ZM18.776,29.505l-8.047-8.047h4.023l4.023,4.023,9.388-9.388h4.023Z",
    transform: "matrix(1, 0, 0, 1, 0, 0.001)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTickBadgeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tick-badge-icon.e5ed5aa7.svg";
export { ForwardRef as ReactComponent };